const THEME_STORAGE_KEY = '__canvopix_theme__'

export type Theme = 'light' | 'dark' | 'radiant' | 'orange'

export const getThemeFromLS = () => {
  const stored = localStorage.getItem(THEME_STORAGE_KEY)
  if (stored) return stored as Theme
  return 'light'
}

export const setThemeToLS = (theme: Theme) => {
  localStorage.setItem(THEME_STORAGE_KEY, theme)
}

export const THEME_TOKENS_MAP = {
  light: {
    colorPrimary: '#000000',
    colorInfo: '#000000',
    colorTextBase: '#000000',
  },
  dark: {
    colorPrimary: '#ffffff',
    colorInfo: '#ffffff',
    colorTextBase: '#ffffff',
  },
  radiant: {
    colorPrimary: '#000000',
    colorInfo: '#000000',
    colorTextBase: '#000000',
  },
  orange: {
    colorPrimary: '#faad14',
    colorInfo: '#faad14',
    colorTextBase: '#333333', 
  },
}

export const getThemeTokens = (theme?: Theme) => {
  const themeTokens = THEME_TOKENS_MAP[theme || getThemeFromLS()]
  return themeTokens
}
